module.exports = __webpack_public_path__ + "static/media/door_open2_icon.7eab34c8.png";